/*
  Keep a sign's extras in step with the sign.

  sections/sss-product.liquid adds each paid extra (wall kit, laminate, ...)
  as its own basket line, linked to the sign by a shared _sss_link property
  and marked with _sss_basis: 'sign' (one per sign) or 'kit' / 'order' (one
  per order line). Shopify does not know they belong together, so:

    - sign removed          -> its extras are removed with it
    - sign quantity changed -> per-sign extras follow; per-kit/per-order stay 1

  Runs once when a page loads (the basket page reloads after every change, so
  this catches those) and after every Horizon cart:update event (the drawer).
  After correcting the basket it reloads the basket page, or asks the drawer
  to re-render, so nothing shows a stale total.
*/
(function () {
  var SOURCE = 'sss-extras';
  var busy = false;

  function reconcile() {
    if (busy || !window.fetch) return;
    busy = true;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var signs = {};
        cart.items.forEach(function (it) {
          var p = it.properties || {};
          if (p._sss_link && !p._sss_basis) signs[p._sss_link] = (signs[p._sss_link] || 0) + it.quantity;
        });
        var updates = {}, n = 0;
        cart.items.forEach(function (it) {
          var p = it.properties || {};
          if (!p._sss_link || !p._sss_basis) return;
          var signQty = signs[p._sss_link] || 0;
          var want = signQty === 0 ? 0 : (p._sss_basis === 'sign' ? signQty : 1);
          if (want !== it.quantity) { updates[it.key] = want; n++; }
        });
        if (!n) return null;
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ updates: updates })
        }).then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        if (!cart) return;
        if (/^\/cart\/?$/.test(location.pathname)) {
          location.reload();
          return;
        }
        document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: { resource: cart, sourceId: SOURCE, data: { source: SOURCE, itemCount: cart.item_count } }
        }));
      })
      .catch(function () { /* the basket is still usable; checkout re-reads it */ })
      .then(function () { busy = false; });
  }

  document.addEventListener('cart:update', function (e) {
    if (e.detail && e.detail.sourceId === SOURCE) return;
    setTimeout(reconcile, 50);
  });

  /* an empty basket has nothing to reconcile, so skip the request */
  if (document.documentElement.dataset.cartCount === '0') return;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', reconcile);
  else reconcile();
})();
